import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import { regex } from "#root/utility/validators";
import type { ReactNode } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { feedCollection } from "#root/schema/platform/newsrpm-parser";
import PageLayout from "./layout";

export default function ({ feedId }: { feedId: string }): ReactNode {
  const navigate = useNavigate();
  const handleDelete = useCallback(() => {
    alert("Feed Deleted");
    navigate("/admin/platform/newsrpm-parser/feed");
  }, [navigate]);

  return (
    <PageLayout title="NewsRPM Parser - Edit Feed">
      <section>
        <h2>{feedId === "new" ? "Create" : "Edit"} Feed</h2>
        <StandardEditor id={feedId} collection={feedCollection} onDelete={handleDelete}>
          <Fields.Set name="id">
            <Fields.Hidden/>
          </Fields.Set>
          <Fields.Set name="providerCode">
            <label>Provider Code</label>
            <Fields.String required validator={regex(/^[a-z\d]*$/, "Lowercase letters and numbers only, no spaces or special characters.")}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="provider">
            <label>Provider</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="uri">
            <label>URL</label>
            <Fields.Domain required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="bodySource">
            <label>Body Source</label>
            <Fields.Select required>
              <Fields.Option value="none">None/Linked Out</Fields.Option>
              <Fields.Option value="contentEncoded">content:encoded element</Fields.Option>
              <Fields.Option value="description">description element</Fields.Option>
            </Fields.Select>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="feedType">
            <label>Feed Type</label>
            <Fields.Select required>
              <Fields.Option value="Press Release">Press Release</Fields.Option>
              <Fields.Option value="News">News</Fields.Option>
              <Fields.Option value="Paid Placement">Paid Placement</Fields.Option>
              <Fields.Option value="Sponsored Content">Sponsored Content</Fields.Option>
              <Fields.Option value="Guest Post">Guest Post</Fields.Option>
            </Fields.Select>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="feedHandler">
            <label>Feed Handler</label>
            <Fields.Select required defaultValue="rss">
              <Fields.Option value="rss">Generic RSS</Fields.Option>
              <Fields.Option value="newsPage">News Page</Fields.Option>
            </Fields.Select>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="retrieveEvery">
            <label># of seconds between retrievals</label>
            <Fields.Integer required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="originator">
            <label>Originated By</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="legacyChannelId">
            <label>Legacy Channel ID #</label>
            <Fields.Number/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="feedOptions">
            <label>Feed Options</label>
            <Fields.JSONEditor rows={10}/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
